module.exports = __webpack_public_path__ + "img/creator-center-entry.de8a8bd3.png";